import React from 'react';
import { styled } from '@linaria/react';
import { animated } from 'react-spring';
import { ChevronLeft } from 'lucide-react';

import useBoop from '@/hooks/use-boop';

import Spacer from '@/components/Spacer';
import VisuallyHidden from '@/components/VisuallyHidden';

import EmojiDemo from './EmojiDemo';
import CircleDemo from './CircleDemo';

function FancyDemos() {
  const [leftArrowStyles, leftArrowTrigger] = useBoop({
    x: -8,
    springConfig: { tension: 200, friction: 22 },
  });

  return (
    <Wrapper>
      <Row>
        <Button
          onClick={leftArrowTrigger}
          onMouseEnter={leftArrowTrigger}
        >
          <IconWrapper style={leftArrowStyles}>
            <ChevronLeft size={48} />
            <VisuallyHidden>Left arrow</VisuallyHidden>
          </IconWrapper>
        </Button>

        <Spacer size={32} />
        <EmojiDemo />

        <Spacer size={32} />
        <CircleDemo />
      </Row>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 48px;
  isolation: isolate;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled(animated.span)`
  display: block;
`;

const Button = styled.button`
  opacity: 0.75;
  color: var(--color-text);

  i,
  svg {
    display: block !important;
  }

  &:hover {
    opacity: 1;
  }
`;

export default FancyDemos;
